module.exports = __webpack_public_path__ + "img/no_zone_selected.7281dbd8.svg";